require('./_wks-define')('observable');



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/es7.symbol.observable.js